import { ConflictType } from '@editor2/types/conflict';
import { PageChildrenReorderConflictResolver } from './childrenReorderResolver';
import { PageDeletedModifiedConflictResolver } from './deletedModifiedResolver';
import { PageItemMoveConflictResolver } from './itemMoveResolver';
import { PageModifiedDeletedConflictResolver } from './modifiedDeletedResolver';
import { PagePropertyConflictResolver } from './propertyResolver';

export class PageResolver {
	getTypeResolver = (key: ConflictType) => {
		switch (key) {
			case ConflictType.Property: {
				const resolver = new PagePropertyConflictResolver();
				return resolver;
			}

			case ConflictType.DeletedModified: {
				const resolver = new PageDeletedModifiedConflictResolver();
				return resolver;
			}

			case ConflictType.ModifiedDeleted: {
				const resolver = new PageModifiedDeletedConflictResolver();
				return resolver;
			}

			case ConflictType.ChildrenReorder: {
				const resolver = new PageChildrenReorderConflictResolver();
				return resolver;
			}

			case ConflictType.ItemMove: {
				const resolver = new PageItemMoveConflictResolver();
				return resolver;
			}

			default:
				break;
		}
	};
}
